module.exports = __webpack_public_path__ + "media/images/ui__warning-1f0738c80337dc9e0b5a24d3e64e0c87.png";